import { URLS } from "../constants";
import { getCheckoutUrlBasedOnEnv, getVersion } from "../helpers";
import { InitializeOptions } from "../types";

/**
 * Former rendering through the checkout iframe, for merchants whose page blocks the eligibility request
 * (CSP, ad blocker…). Checkout logs these loads thanks to the `fallback` parameter.
 */
export function replaceWithIframe(host: HTMLElement, options: InitializeOptions) {
  // Unmounted, or initialized again, in the meantime
  if (!host.isConnected) return;

  const {
    environment,
    merchantId,
    selector,
    amountInCents,
    installmentsCount,
    deferredDays,
    deferredMonths,
    locale,
    captureMethod,
    style,
    onIntegratedPayButtonClicked,
    checkoutUrl,
  } = options;

  const url = new URL(
    getCheckoutUrlBasedOnEnv(environment ?? "PROD", checkoutUrl) + URLS.embedded
  );
  url.searchParams.append("merchantId", merchantId);
  url.searchParams.append("amountInCents", amountInCents.toString());
  url.searchParams.append("installmentsCount", installmentsCount.toString());
  if (deferredDays) {
    url.searchParams.append("deferredDays", deferredDays.toString());
  }
  if (deferredMonths) {
    url.searchParams.append("deferredMonths", deferredMonths.toString());
  }
  url.searchParams.append("locale", locale ?? "FR");
  url.searchParams.append("captureMethod", captureMethod ?? "automatic");
  url.searchParams.append("domElement", selector);
  url.searchParams.append("style", JSON.stringify(style || null));
  url.searchParams.append("inPageVersion", getVersion());
  if (onIntegratedPayButtonClicked) {
    url.searchParams.append("showPayButton", "true");
  }
  url.searchParams.append("fallback", "true");

  const iframe = document.createElement("iframe");
  iframe.src = url.toString();
  iframe.id = `alma-embedded-iframe-${selector}`;
  iframe.style.width = "100%";
  iframe.style.height = "150px";
  iframe.style.transition = "height 0.5s";
  iframe.style.border = "none";
  // `block` removes space under iFrame, `none` hides for credit
  iframe.style.display = host.style.display === "none" ? "none" : "block";
  // Give access to Payment Request API
  iframe.setAttribute("allow", "payment");
  host.replaceWith(iframe);

  window.addEventListener("message", function listener(event) {
    if (!iframe.isConnected) {
      window.removeEventListener("message", listener);
      return;
    }
    if (event.origin !== url.origin || event.source !== iframe.contentWindow) return;

    if (event.data.type === "embedded_height") {
      iframe.style.height = `${Math.ceil(event.data.payload)}px`;
    } else if (
      event.data.type === "in_page_status" &&
      event.data.payload === "ready_for_payment"
    ) {
      onIntegratedPayButtonClicked?.();
    }
  });
}
